<template>
  <div>
    <br class="hidden-xs-only" />
    <div class="kongxi hidden-sm-and-up"></div>
    <el-card shadow="always" :body-style="{ padding: '20px' }">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item :to="{ path: '/news' }">新闻动态</el-breadcrumb-item>
        <el-breadcrumb-item>新闻详情</el-breadcrumb-item>
      </el-breadcrumb>
      <div class="content">
        <h2>全力打造低空场景之城｜破解行业痛点，广东东进无人机重塑有害生物防控模式</h2>
        <div id="meta_content">
          <span class="rich_b"> 东进防控 </span>
          <span id="rich_c">
            <span>2025-10-31 12:49</span>
            广东
          </span>
        </div>
        <p>
          在城市化与生态文明建设协同发展的今天，传统的有害生物防控模式正面临严峻挑战。广东东进有害生物防控技术有限公司积极探索，将多旋翼无人机技术与行业深度融合，为行业转型升级提供了全新范式。
        </p>
        <h3 style="font-weight: 700; font-size: 16px; color: #000">
          无人机技术破局，构建智能防控体系
        </h3>
        <p>
          在服务黄江、道滘、石排、企石、莞城等多个镇街及市属企业的过程中，广东东进发现传统病媒生物（蚊、蝇、鼠、蟑螂）及白蚁防控工作普遍存在五大痛点：
        </p>
        <p>一是巡查效率低，依赖人工徒步巡查，覆盖范围有限，难以实现全域常态化监测。</p>
        <p>二是数据滞后，依靠手工记录与统计，数据更新慢，难以支撑实时决策。</p>
        <p>
          三是作业风险高，部分区域如建筑工地、待建地（荒地）、密林、污水管网等环境复杂，人工作业存在安全隐患。
        </p>
        <p>
          四是应急响应迟缓，面对突发的疫情或虫害事件时，人工调度与处置速度不足，影响控制效果。
        </p>
        <p>
          五是评价体系不完善，缺乏系统化、可视化的防控效果评估手段，难以量化治理成效。
        </p>
        <img width="100%" :src="img[0]" alt="" />
        <h3 style="text-align: center; margin: 5px 0; color: #7f7f7f; font-size: 14px">
          无人机病媒生物传染病应急防控作业
        </h3>
        <p>
          针对上述痛点，广东东进公司基于多旋翼无人机平台，搭载高精度传感与施药系统，打造了一套完整的“低空+城市管理”智能防控体系，实现了四大核心突破：
        </p>
        <p>
          第一，全域高效巡查。通过无人机航拍与多光谱成像技术，快速识别蚊蝇孳生地、鼠类活动痕迹、白蚁巢穴等，实现大范围、高频次自动巡检，覆盖传统人力难以触及的区域。
        </p>
        <p>
          第二，实时数据采集与AI识别。无人机采集的图像与视频数据实时回传至AI分析平台，平台自动识别病媒生物密度、分布情况并评定白蚁危害等级，即时生成动态热力图与风险预警报告。
        </p>
        <p>
          第三，精准施药与快速响应。在识别高风险区域后，无人机可精准喷洒灭蚊蝇药物、投掷灭蚊幼剂等，实现“识别-定位-处置”一体化作业，大幅提升应急响应速度与精准度。
        </p>
        <p>
          第四，防控效果可视化评价。通过对比前后数据与防控成效分析，生成可视化评价报告，为客户提供科学、客观的防控水平评估依据，助力城市创建“病媒生物密度控制水平达标区”。
        </p>
        <p>
          截至2025年9月，该解决方案已在大岭山、道滘、黄江、石排等镇街建立了多个有害生物防治示范应用场景，在公共环境常规有害生物防治及基孔肯雅热和登革热防控中发挥了重要作用。累计数据充分证明了其有效性：应用试点超过12个月，无人机飞行超150架次，总飞行时长约450小时，总飞行里程超600公里，喷洒杀虫剂药物超2.5吨，拍摄照片超5000张，视频约400条。
        </p>
        <h3 style="font-weight: 700; font-size: 16px; color: #000">
          全流程服务闭环，推动行业转型升级
        </h3>
        <p>
          广东东进构建了“需求调研—航线规划—无人机执飞—数据回传—智能分析—报告输出”的全流程服务模式，支持镇街常态化有害生物防控巡检与突发事件应急调度。
        </p>
        <p>
          这一创新模式为城市管理带来了显著的场景价值——效率提升：巡查效率提升超过5倍，实现全域覆盖；管理精细化：实现数据实时更新与风险可预警，支撑城市精细化管理；安全与响应：有效降低人工作业风险，全面提升应急响应能力；模式转型：推动病媒生物防控从传统的“人防”向现代化的“技防+智防”战略转型。
        </p>
        <img width="100%" :src="img[1]" alt="" />
        <h3 style="text-align: center; margin: 5px 0; color: #7f7f7f; font-size: 14px">
          无人机病媒生物防治——喷酒药物
        </h3>
        <p>
          广东东进通过无人机技术的创新应用，成功开辟了低空经济与传统行业结合的新路径。这不仅是一次技术工具的升级，更是一次治理理念的变革，为构建更安全、更健康、更宜居的城市环境提供了坚实的技术支撑，预示着有害生物防控全面步入智能化、精准化的新时代。
        </p>
        <h3>我们还提供多元化服务</h3>
        <img width="100%" :src="img[2]" alt="" />
        <h3>扫码关注我们了解更多</h3>
        <div>
          <img :src="img[3]" alt="" />
        </div>
      </div>
      <br />
      <br />
      <el-row :gutter="20">
        <el-col :span="12" :xs="24" :offset="0">
          <span>&nbsp;</span>
        </el-col>
        <el-col
          :span="12"
          :xs="24"
          :offset="0"
          style="text-align: right"
          class="hidden-xs-only"
        >
          <span
            style="cursor: pointer; color: #666; font-size: 14px"
            @click="$router.push({ name: 'News16' })"
            >国企担当 专业守护：东进公司全...&nbsp;&nbsp;&nbsp;&nbsp;下一条 &gt;</span
          >
        </el-col>
      </el-row>
      <br />
      <br />
    </el-card>
    <br class="hidden-xs-only" />
    <div class="kongxi hidden-sm-and-up"></div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      img: [
        require("@/assets/news17_1.jpg"),
        require("@/assets/news17_2.png"),
        require("@/assets/news8-4.png"),
        require("@/assets/news8-7.png"),
      ],
    };
  },
};
</script>

<style lang="scss" scoped>
.black {
  font-weight: 700;
}

.kongxi {
  height: 10px;
}

.big-div {
  display: flex;
  justify-content: space-evenly;
}

.small-div {
  text-align: center;
}

.small-div1 img {
  width: 258px;
  height: 258px;
}

.small-div2 img {
  width: auto;
  height: auto;
}

.caption {
  font-size: 14px;
  margin-top: 10px;
  text-align: center;
}

.content {
  width: 90%;
  margin: 0 auto;

  h2 {
    font-family: 黑体, SimHei;
    font-size: 24px;
    margin: 20px 0;
    text-align: center;
  }

  h3 {
    font-weight: normal;
    font-family: 黑体, SimHei;
    font-size: 18px;
    margin: 20px 0;
    text-align: left;
  }

  p {
    font-size: 16px;
    margin: 20px 0;
    text-align: justify;
    text-indent: 2em;
    color: #515050;
    font-family: "Microsoft YaHei", Verdana, Geneva, sans-serif;
  }
}

.wenzi {
  margin: 0 !important;
  color: rgb(255, 255, 255) !important;
}

@media screen and (max-width: 768px) {
  .content {
    width: 90%;
    margin: 0 auto;

    h2 {
      margin: 20px 0;
      text-align: center;
      font-size: 24px;
    }

    h3 {
      font-size: 18px;
      margin: 20px 0;
      text-align: left;
    }

    p {
      margin: 10px 0;
      text-align: justify;
      text-indent: 2em;
      font-size: 16px;
      color: #515050;
      font-family: "Microsoft YaHei", Verdana, Geneva, sans-serif;
    }
  }
}

#meta_content {
  font-size: 15px;
  padding-left: 2.6em;

  span {
    color: rgba(0, 0, 0, 0.3);
  }

  .rich_b {
    color: #576b95 !important;
  }
}
</style>
